import { PageHeader } from '@core/components/PageHeader';
import { SearchBar } from '@core/components/SearchBar';
import Tour from '@core/components/Tour';
import { useApiUtils } from '@core/util/apiUtils';
import FusePageCarded from '@fuse/core/FusePageCarded';
import { usuarioApi } from 'app/services/api/usuarioApi';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext';
import { initializeReactGA } from 'app/utils/analyticsUtil';
import React, { useContext, useEffect, useState } from 'react';
import { FaCalendarCheck } from 'react-icons/fa';
import { useHistory } from 'react-router';
import { ImpostoCadastroModal } from './components/ImpostoCadastroModal';
import { ImpostoTable } from './components/ImpostoTable';
import { ImpostoVisualizacaoModal } from './components/ImpostoVisualizacaoModal';
import { steps } from './components/steps/steps';
import { ImpostoAction } from './store/impostoAction';
import { ImpostoProvider, useImposto } from './store/impostoContext';

const SearchHeader = () => {
  const [state, dispatch] = useImposto();

  return (
    <PageHeader title="Impostos" icon={<FaCalendarCheck />}>
      <div className="flex items-center w-full max-w-512 stepBarraPesquisa">
        <SearchBar
          searchText={state.pesquisa}
          onChange={(value) => {
            dispatch(ImpostoAction.setQuery(value));
          }}
        />
      </div>
    </PageHeader>
  );
};

const ImpostoContent = () => {
  const history = useHistory();
  const [state, dispatch] = useImposto();
  const apiUtils = useApiUtils(dispatch, Actions);

  const [run, setRun] = useState(false);
  const [tour, setTour] = useState(false);
  const [, setLoading] = useState(false);
  const [funcionalidadesTour, setFuncionalidadesTour] = useContext(GlobalContext).funcionalidadesTour;

  const onFetchData = (params) => {
    const funcionalidadeJaExistente = funcionalidadesTour?.some((e) => e === 'IMPOSTOS');
    if (!funcionalidadeJaExistente) {
      setRun(true);
      setTour(true);
      ImpostoAction.buscarTour(dispatch);
    } else {
      ImpostoAction.buscarRegistros(dispatch, params);
    }
  };

  useEffect(() => {
    initializeReactGA(history?.location?.pathname);
    if (!funcionalidadesTour) {
      setFuncionalidadesTour([]);
    }
    onFetchData({
      page: state?.requestParams?.page,
      q: state?.requestParams?.q,
      size: state?.requestParams?.size,
      sort: state?.requestParams?.sort,
    });
    // Efeito de montagem: incluir as dependências reexecutaria a carga inicial a cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const atualizarTour = async () => {
    try {
      setLoading(true);
      funcionalidadesTour.push('IMPOSTOS');
      await usuarioApi.updateTour(funcionalidadesTour);
      setRun(false);
      setTour(false);
      setFuncionalidadesTour(funcionalidadesTour);
      onFetchData({
        page: state?.requestParams?.page,
        q: state?.requestParams?.q,
        size: state?.requestParams?.size,
        sort: state?.requestParams?.sort,
      });
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FusePageCarded
      innerScroll
      header={<SearchHeader />}
      content={
        <>
          <Tour steps={steps} run={run} setRun={setRun} onFinish={() => atualizarTour()} disableScrolling={true} />
          <ImpostoTable onTour={tour} onFetchData={onFetchData} />
          <ImpostoCadastroModal />
          <ImpostoVisualizacaoModal />
        </>
      }
    />
  );
};

const Imposto = () => {
  return (
    <ImpostoProvider>
      <ImpostoContent />
    </ImpostoProvider>
  );
};

export default Imposto;
